var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 9.32c0-3.734-3.57-6.393-7.108-5.386A6.954 6.954 0 0014.5 0C10.77 0 7.717 2.949 7.55 6.637c-3.455.787-5.644 4.221-4.915 7.67.05.239.339.332.518.168a5.669 5.669 0 014.27-1.474.307.307 0 00.274-.13c.406-.573.9-1.086 1.464-1.51 3.979-2.993 9.75-.79 10.724 4.074.02.1.09.185.185.224a6.428 6.428 0 013.56 3.616c.046.12.161.199.29.199h2.899c2.807 0 5.136-2.235 5.18-5.041a5.126 5.126 0 00-4.124-5.112z",
    fill: "#2CACD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 17.2a4.776 4.776 0 00-4.76-5.2 4.781 4.781 0 00-4.576 3.387c-2.718-1.393-5.895.972-5.279 4.003C1.367 19.39 0 20.958 0 22.695A3.307 3.307 0 003.31 26h14.34a4.41 4.41 0 004.413-4.407 4.41 4.41 0 00-4.064-4.392z",
    fill: "#2CACD7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "b579165a089879e9d7828ba3dfcbdf78.svg";
export { MemoForwardRef as ReactComponent };